<template>
    <div class="TQ_borderRadius TQ_inline TQ_clickable TQ_direction_rtl">

        <div class="TQ_inline TQ_padding_8px"
             @click="pe_onChangeOption_f(index_n)"
             :class="{'TQ_borderRadius_right' :  index_n === 0, 'TQ_borderRight' : index_n > 0, 'TQ_borderRadius_left' :  index_n === p_options_as.length -1, 'TQ_bg_purple' : p_selectedOptionIndex_an.includes(index_n)}"
             v-for="(option_s, index_n) in p_options_as">

            <div v-if="!p_displayAsToolTip_b" >
                {{option_s}}
            </div>
            <div v-if="p_optionsImages_as[index_n]" :title="p_displayAsToolTip_b && option_s">
                <tq-image :pb_src_r="p_optionsImages_as[index_n]" :style="'width:' + p_imageWidth_s" class=" TQ_verticalAlignMiddle"/>
            </div>
        </div>

    </div>
</template>

<script>
    import TqImgFillBlur from "../basic2/TqImgFillBlur";
    import TqImage from "./TqImage";
    export default {
        name: "TqToggleMultiOptions",
        components: {TqImage, TqImgFillBlur},
        props : {
            p_options_as: {
                type: Array,
                require: true,
            },
            p_optionsImages_as: {
                type: Array,
                default() {return []},
            },
            p_selectedOptionIndex_an:{
                type: Array,
                require: true,
            },
            p_imageWidth_s:{
                type: String,
                default : "24px"
            },
            p_displayAsToolTip_b:{
                type: Boolean,
                default : false
            },
            pe_onChangeOption_f:{
                type: Function,
                require: true,
            }

        },
    }
</script>

<style scoped>

</style>